export const AppLayoutActions = {
    UPDATE_SIDEBAR: 'UPDATE_SIDEBAR',
    UPDATE_CHAT_SETTINGS: 'UPDATE_CHAT_SETTINGS',
    RESET_CHAT_SETTINGS: 'RESET_CHAT_SETTINGS',
}

export const updateSidebarAction = (payload: any) => {
    return {
        type: AppLayoutActions.UPDATE_SIDEBAR,
        payload,
    }
}

export const updateChatSettingsAction = (payload: any) => {
    return {
        type: AppLayoutActions.UPDATE_CHAT_SETTINGS,
        payload,
    }
}

export const resetChatSettingsAction = () => {
    return {
        type: AppLayoutActions.RESET_CHAT_SETTINGS,
    }
}

export const initialState = {
    sidebar: {
        open: false,
    },
    chatSettings: {},
}

export const appLayoutReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case AppLayoutActions.UPDATE_SIDEBAR:
            return { ...state, sidebar: { ...state.sidebar, ...action.payload } }
        case AppLayoutActions.UPDATE_CHAT_SETTINGS:
            return {
                ...state,
                chatSettings: {
                    ...state.chatSettings,
                    [action.payload.orgID]: action.payload,
                }
            }
        case AppLayoutActions.RESET_CHAT_SETTINGS:
            return { ...state, chatSettings: { ...initialState.chatSettings } }
        default:
            return state;
    }
};